import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'contrato-tipo-acao');

const tipoAcaoActions = {
  ...genericActions(basePath),
  buscarAtivos: { method: 'GET', url: `${basePath}/ativos` },
  buscarTipoAcaoComConfiguracao: { method: 'GET', url: `${basePath}/{idTipoAcao}/configuracao` },
  buscarTipoAcao: { method: 'GET', url: `${basePath}/{id}` },
};

export default resource => resource(`${basePath}`, {}, tipoAcaoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/tipo-acao.js